import {MaterialDemandByDay} from '@domain/material-demand'
import {ApiClient} from '@hconnect/apiclient'
import {AttachmentFile} from '@hconnect/common/types'
import {AxiosResponseHeaders} from 'axios'
import readExcel, {Row} from 'read-excel-file'

export const salesForecastQueryKeys = {
  materialDemand: 'salesForecast.materialDemand',
  readSalesForecastExcel: 'salesForecast.readExcel',
  downloadTemplate: 'salesForecast.downloadTemplate'
} as const

export const fetchMaterialDemand = async (
  plantCode: string,
  fromDate: string,
  toDate: string,
  signal?: AbortSignal
): Promise<MaterialDemandByDay> => {
  const response = await ApiClient.axiosInstance.get<MaterialDemandByDay>(
    `/plants/${plantCode}/material-demand/daily`,
    {params: {from: fromDate, to: toDate}, signal}
  )
  return response.data
}

export const fetchDownloadSalesForecastExcelTemplate = async (
  plantCode: string
): Promise<[Blob, AxiosResponseHeaders]> => {
  const {data, headers} = await ApiClient.axiosInstance.get<Blob>(
    `/plants/${plantCode}/material-demand/sales-forecast/template`,
    {
      responseType: 'blob',
      transformRequest: (data, reqHeaders) => {
        if (reqHeaders) {
          reqHeaders['Accept'] = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
        return data
      }
    }
  )
  return [data, headers]
}

export const fetchReadSalesForecastExcel = async (
  file: AttachmentFile
): Promise<Row[] | undefined> => {
  if (!file.originalFile) return undefined
  const rows = await readExcel(file.originalFile)
  const columnRowIndex = 5
  rows.splice(0, columnRowIndex)
  return rows
}
